import React from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { localizedPath, urlLanguage, useLang } from "@/lib/i18n";
import { useSettings } from "@/lib/SettingsContext";
import { Languages, Sparkles } from "lucide-react";
import AccountNav from "@/components/AccountNav";

export default function PublicNav() {
  const { lang, setLang, t, pick, lp } = useLang();
  const { settings } = useSettings();
  const loc = useLocation();
  const navigate = useNavigate();
  if (loc.pathname.startsWith("/admin")) return null;
  const toggleLanguage = () => {
    const next = lang === "id" ? "en" : "id";
    setLang(next);
    // Localized public pages switch to their other-language URL.
    if (urlLanguage(loc.pathname)) {
      navigate(localizedPath(`${loc.pathname}${loc.search}${loc.hash}`, next));
    }
  };
  const brand = pick(settings || {}, "brand_name") || "Ruang Refleksi";
  return (
    <header className="glass-nav sticky top-0 z-40 border-b border-border/60">
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 py-4">
        <Link to={lp("/")} data-testid="brand-link" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-full bg-terracotta-500/90 grid place-items-center text-cream-50 shadow-sm ring-1 ring-terracotta-600/30 group-hover:rotate-3 transition-transform">
            <Sparkles className="w-4 h-4" strokeWidth={1.8} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-semibold text-lg tracking-tight" data-testid="brand-name">{brand}</div>
            <div className="hidden text-[11px] text-muted-foreground -mt-0.5 sm:block">Self-Exploration Platform</div>
          </div>
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <NavLink to={lp("/")} end data-testid="nav-home" className={({isActive}) => `text-sm hover:text-primary transition-colors ${isActive ? "text-primary" : "text-foreground/80"}`}>{t("nav.home")}</NavLink>
          <NavLink to={lp("/instruments")} data-testid="nav-catalogue" className={({isActive}) => `text-sm hover:text-primary transition-colors ${isActive ? "text-primary" : "text-foreground/80"}`}>{t("nav.catalogue")}</NavLink>
          <a href="#how-it-works" data-testid="nav-about" className="text-sm text-foreground/80 hover:text-primary">{t("nav.about")}</a>
        </div>
        <div className="flex items-center gap-1 sm:gap-2">
          <button
            data-testid="lang-toggle"
            onClick={toggleLanguage}
            className="flex items-center gap-1 px-3 py-1.5 rounded-full border border-border text-xs uppercase tracking-wider hover:bg-secondary transition-colors"
          >
            <Languages className="w-3.5 h-3.5" />
            {lang === "id" ? "ID" : "EN"}
          </button>
          <AccountNav />

        </div>
      </nav>
    </header>
  );
}
